import { Event } from '../types/Event';

export const isEventAdmin = (event: Event, userId: string | undefined): boolean => {
  if (!userId) return false;
  
  // Creator is always an admin
  if (event.creator === userId) {
    return true;
  }
  
  // Check if user is in admins array
  if (event.admins && event.admins.length > 0) {
    return event.admins.includes(userId);
  }
  
  return false;
};

export const canManageEvent = (event: Event, userId: string | undefined, isSiteOwner: boolean): boolean => {
  // Site owner can manage all events on their site
  if (isSiteOwner) {
    return true;
  }
  
  // Check if user is event admin
  return isEventAdmin(event, userId);
}; 